// UI strings for the clip problem tags (src/showclips/tags.ts, engine/src/show-clip-tags.ts): the
// one-tap "Leike" row under a show line in Sarjan repliikit — five tags on a clip, or "Merkitse:
// leike puuttuu" on a line without one (a toggle to set, not a status). A set tag shows "merkitty" and undoes with one tap. Finnish (default) and
// English side by side; en has the same shape. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';
import type { ShowClipTagKind } from '@valyrio/engine/show-clip-tags';

export const clipTagsFi = {
  /** The row's label. */
  label: 'Leike',
  /** The row's label on a line without a clip: its one tag is something to set, not a state. */
  markLabel: 'Merkitse',
  tags: {
    'short-start': 'liian lyhyt alku',
    'short-end': 'liian lyhyt loppu',
    'too-long': 'liian pitkä',
    'wrong-line': 'väärä repliikki',
    'bad-audio': 'huono ääni',
    missing: 'leike puuttuu',
  } satisfies Record<ShowClipTagKind, string>,
  /** Beside a tag I have set. */
  marked: 'merkitty',
  /** A tag button's accessible name: set it, or (set) undo it. */
  aria: (tag: string, mine: boolean) => (mine ? `${tag}: merkitty. Poista merkintä` : `Merkitse leike: ${tag}`),
  /** The accessible name of "puuttuu" (on a line without a clip). */
  missingAria: (mine: boolean): string => (mine ? 'Leike puuttuu: merkitty. Poista merkintä' : 'Merkitse, että leike puuttuu'),
  /** The partner set the same tag. */
  markedBy: (name: string) => `${name} merkitsi`,
};

export const clipTagsEn: typeof clipTagsFi = {
  label: 'Clip',
  markLabel: 'Tag',
  tags: {
    'short-start': 'start cut short',
    'short-end': 'end cut short',
    'too-long': 'too long',
    'wrong-line': 'wrong line',
    'bad-audio': 'bad audio',
    missing: 'clip missing',
  },
  marked: 'tagged',
  aria: (tag, mine) => (mine ? `${tag}: tagged. Remove the tag` : `Tag the clip: ${tag}`),
  missingAria: (mine) => (mine ? 'Clip missing: tagged. Remove the tag' : 'Tag the clip as missing'),
  markedBy: (name) => `${name} tagged it`,
};

// Messages.clipTags (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('clipTags', clipTagsFi, clipTagsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof clipTagsFi> {}
}
